module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_vm._m(0), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_vm._m(1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('NbTank', {
    attrs: {
      "tank": _vm.tank
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "word-wrap": "break-word"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(JSON.stringify(_vm.tank)) + "\n\t\t")])]), _vm._v(" "), _c('div', {
    staticClass: "row mt20"
  }, [_vm._m(2), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12"
  }, [_c('NbTank', {
    attrs: {
      "tank": _vm.remoteTank,
      "edit": false
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12",
    staticStyle: {
      "word-wrap": "break-word"
    }
  }, [_vm._v("\n\t\t\t" + _vm._s(JSON.stringify(_vm.remoteTank)) + "\n\t\t")])])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "alert alert-info"
  }, [_c('p', [_c('b', [_vm._v("NbTank可以传入两个参数")])]), _vm._v(" "), _c('ul', [_c('li', [_vm._v("\n\t\t\t\ttank就是一个文件Tank.js类型\n\t\t\t")]), _vm._v(" "), _c('li', [_vm._v("\n\t\t\t\tedit true:表示是编辑模式，用户可以重新上传。 false：表示非编辑模式，只能下载\n\t\t\t")])]), _vm._v(" "), _c('p', [_c('b', [_vm._v("tank中可以设置的属性有")])]), _vm._v(" "), _c('ul', [_c('li', [_c('span', [_vm._v("\n\t\t\t\t\tfilter 允许上传的文件类型\n\t\t\t\t")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("* 表示允许所有类型")]), _vm._v(" "), _c('li', [_vm._v("可以上传的文件后缀名， 用|分隔，如：.pdf|.doc|.ppt")]), _vm._v(" "), _c('li', [_vm._v("可以上传的文件类型，text,audio,video,image 四种的组合，用|分隔，如：image|audio")])])]), _vm._v(" "), _c('li', [_c('span', [_vm._v("privacy")]), _vm._v(" "), _c('ol', [_c('li', [_vm._v("false表示无需授权任何人均可访问该文件")]), _vm._v(" "), _c('li', [_vm._v("true表示必须授权才能访问该文件")])])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('b', [_vm._v("\n\t\t\t\t上传演示\n\t\t\t")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "col-xs-12"
  }, [_c('b', [_vm._v("\n\t\t\t\t仅下载演示\n\t\t\t")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/_vue-loader@11.3.4@vue-loader/lib/template-compiler?{"id":"data-v-41d9c4e4"}!./~/_vue-loader@11.3.4@vue-loader/lib/selector.js?type=template&index=0!./src/backyard/view/wheel/NbTankDemo.vue
// module id = 974
// module chunks = 1